<template>
  <div class="ms-word-page container py-4">
    <!-- Page Heading -->
    <h2 class="mb-4">MS Word</h2>

    <!-- Description / Introduction -->
    <p>
      MS Word is a powerful word processing application used to create
      documents, letters, reports, and more. It offers features like text
      formatting, images, tables, styles, and templates.
    </p>

    <!-- Example Features List -->
    <h5 class="mt-4">Key Features of MS Word:</h5>
    <ul>
      <li>Creating and formatting documents</li>
      <li>Inserting tables, images, and charts</li>
      <li>Using styles and templates for consistency</li>
      <li>Track changes and collaboration</li>
      <li>Spell check, grammar check, and proofing tools</li>
    </ul>

    <!-- Example Image / Screenshot -->
    <div class="mt-4 text-center">
      <img
        src="@/assets/Tutorials/MSOffice/ms-word.png"
        alt="MS Word Example"
        class="img-fluid rounded shadow-sm"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MsWord",
};
</script>

<style scoped>
h2 {
  color: #1e40af; /* Blue heading */
  font-weight: 700;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

p {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
